import React from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";
import { Popover } from "antd";

import { getListStyle } from "./Utils";
import StepPopupUnassign from "./StepPopupUnassign";

const DriverAssign = ({
  driver,
  stepsHovered,
  setStepsHovered,
  onClickStep,
  onHoverStep,
  handleCloseStepPopup,
  isDragging,
  actionDnd,
  assignStops,
  isLive,
  solutionId,
  selectedMultipleSteps,
  multipleStepState,
  setAllInclusiveMultipleSteps,
}) => {
  const isDropDisabled = actionDnd === "sort";
  const newClickStep = (e, step) => {
    if ((e.ctrlKey || e.metaKey) && selectedMultipleSteps) {
      selectedMultipleSteps && selectedMultipleSteps(step, solutionId);
    } else if (e.shiftKey) {
      setAllInclusiveMultipleSteps && setAllInclusiveMultipleSteps(step, solutionId);
    } else {
      onClickStep(step.orderId, step.type);
    }
  };
  return (
    <Droppable
      key={`scrollCustom assign_${driver._id}`}
      droppableId={`assign_${driver._id}`}
      direction="horizontal"
      isDropDisabled={isDropDisabled || isLive}>
      {(provided, snapshot) => (
        <div
          className={`assign-steps ${isDragging && "isDragging"} ${actionDnd}`}
          style={{
            width: "150px",
            display: "flex",
            alignItems: "center",
            height: "40px",
            overflow: "auto",
            paddingRight: "10px",
            userSelect: "none",
            ...getListStyle(isDragging, snapshot.isDraggingOver, actionDnd === "sort"),
          }}
          ref={provided.innerRef}
          {...provided.droppableProps}>
          {assignStops.map((stop, index) => {
            const stepPopover = `StepPopover-${stop.orderId}-${stop.type.toLowerCase()}`;
            const isMultipleSelected = multipleStepState?.steps?.find(
              item => item.orderId === stop.orderId && item.type === stop.type && item.driverId === solutionId,
            );
            return (
              <Draggable key={stepPopover} draggableId={stepPopover} index={index}>
                {providedDrag => (
                  <div
                    ref={providedDrag.innerRef}
                    {...providedDrag.draggableProps}
                    {...providedDrag.dragHandleProps}
                    style={{
                      zIndex: 999,
                      width: 24,
                      marginLeft: "8px",
                      ...providedDrag.draggableProps.style,
                    }}>
                    <Popover
                      key={index}
                      trigger="hover"
                      open={stepsHovered[stepPopover] || false}
                      content={
                        <StepPopupUnassign
                          step={stop}
                          stepPopover={stepPopover}
                          setStepsHovered={setStepsHovered}
                          onClickStep={onClickStep}
                        />
                      }>
                      <div
                        className={`${stop.type.toLowerCase() === "pickup" ? "unit" : "unit unit2"} ${stepPopover}`}
                        style={{
                          borderColor: stop.color,
                          color: stop.color,
                          borderWidth: isMultipleSelected ? "3px" : "1px",
                        }}
                        onClick={e => newClickStep(e, stop)}
                        onMouseOver={() => onHoverStep(stop.orderId, stop.type)}
                        onMouseOut={() => handleCloseStepPopup()}>
                        {stop.index + 1}
                      </div>
                    </Popover>
                  </div>
                )}
              </Draggable>
            );
          })}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export default DriverAssign;
